var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "meat-content" },
    [
      _c(
        "el-button",
        {
          staticClass: "add-button",
          attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
          on: { click: _vm.addFormItem },
        },
        [_vm._v("新增内容")]
      ),
      _vm._v(" "),
      _c(
        "draggable",
        {
          attrs: { handle: ".drag-handle" },
          model: {
            value: _vm.meatLists,
            callback: function ($$v) {
              _vm.meatLists = $$v
            },
            expression: "meatLists",
          },
        },
        _vm._l(_vm.meatLists, function (item, i) {
          return _c(
            "el-card",
            { key: i, staticClass: "meat-item", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                {
                  staticClass: "flex header-content",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("div", { staticClass: "flex drag-handle" }, [
                    _c("div", { staticClass: "el-icon-rank drag-icon" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          "内容" +
                            (i + 1) +
                            "：" +
                            (_vm.meatLists[i].formTitle || "")
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  i > 0
                    ? _c(
                        "el-tooltip",
                        { attrs: { content: "删除", placement: "top" } },
                        [
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-delete",
                              size: "mini",
                              type: "danger",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeMeat(i)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v("标签类型：")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "input-field",
                      attrs: { clearable: "", placeholder: "请选择" },
                      on: {
                        change: function ($event) {
                          return _vm.changeType(item.type, i)
                        },
                      },
                      model: {
                        value: _vm.meatLists[i].type,
                        callback: function ($$v) {
                          _vm.$set(_vm.meatLists[i], "type", $$v)
                        },
                        expression: "meatLists[i].type",
                      },
                    },
                    _vm._l(_vm.TAG_OPTIONS, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              item.type != "tips"
                ? _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("标签名称："),
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "input-field",
                        attrs: { placeholder: "请填写" },
                        model: {
                          value: _vm.meatLists[i].formTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.meatLists[i], "formTitle", $$v)
                          },
                          expression: "meatLists[i].formTitle",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              ["input", "textarea", "select", "phone", "tips"].includes(
                item.type
              )
                ? _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("提示文字："),
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "input-field",
                        attrs: { placeholder: "请填写" },
                        model: {
                          value: _vm.meatLists[i].placeholder,
                          callback: function ($$v) {
                            _vm.$set(_vm.meatLists[i], "placeholder", $$v)
                          },
                          expression: "meatLists[i].placeholder",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type != "tips"
                ? _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("是否必填："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.meatLists[i].isRequired,
                            callback: function ($$v) {
                              _vm.$set(_vm.meatLists[i], "isRequired", $$v)
                            },
                            expression: "meatLists[i].isRequired",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              ["select", "radio", "checkbox"].includes(item.type)
                ? _c("div", { staticClass: "form-item options-container" }, [
                    _c("div", { staticClass: "label" }, [_vm._v("选项：")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "options-list" },
                      _vm._l(item.options, function (optionItem, idx) {
                        return _c(
                          "div",
                          { key: idx, staticClass: "option-item" },
                          [
                            _c("el-input", {
                              staticClass: "option-input",
                              attrs: { placeholder: "请填写" },
                              model: {
                                value: optionItem.name,
                                callback: function ($$v) {
                                  _vm.$set(optionItem, "name", $$v)
                                },
                                expression: "optionItem.name",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "options-actions" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "添加选项",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "success",
                                        icon: "el-icon-plus",
                                        size: "mini",
                                        circle: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addOption(i)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                idx > 0
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "删除选项",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            type: "danger",
                                            icon: "el-icon-delete",
                                            size: "mini",
                                            circle: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeOption(
                                                i,
                                                idx,
                                                item.options
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              ["input", "textarea", "select", "radio", "checkbox"].includes(
                item.type
              )
                ? _c(
                    "div",
                    { staticClass: "form-item" },
                    [
                      _c("div", { staticClass: "label" }, [_vm._v("默认值：")]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "input-field",
                        attrs: { placeholder: "请填写" },
                        model: {
                          value: _vm.meatLists[i].defaultValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.meatLists[i], "defaultValue", $$v)
                          },
                          expression: "meatLists[i].defaultValue",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "meat-item settings-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            { staticClass: "flex", attrs: { slot: "header" }, slot: "header" },
            [
              _c("div", { staticClass: "el-icon-setting settings-icon" }),
              _vm._v(" "),
              _c("span", [_vm._v("表单提交配置")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-item" },
            [
              _c("div", { staticClass: "label" }, [_vm._v("提交跳转：")]),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.redirectType,
                    callback: function ($$v) {
                      _vm.redirectType = $$v
                    },
                    expression: "redirectType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v("返回上一页"),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("指定页")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.redirectType === 2
            ? _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v("跳转链接：")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "input-field",
                      attrs: {
                        filterable: "",
                        placeholder: "请选择链接",
                        "remote-method": _vm.remoteMethod,
                        loading: _vm.loading,
                        remote: "",
                      },
                      on: { change: _vm.handleLinkChange },
                      model: {
                        value: _vm.selectedLinkId,
                        callback: function ($$v) {
                          _vm.selectedLinkId = $$v
                        },
                        expression: "selectedLinkId",
                      },
                    },
                    _vm._l(_vm.linkList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label:
                            item.id +
                            "-" +
                            item.urlName +
                            "-" +
                            item.url +
                            (item.urlParam ? "?" + item.urlParam : ""),
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }